import {createI18n, type I18nOptions} from 'vue-i18n';

export const i18n_DEFAULT_LOCALE = 'en';

const setI18nLanguage = (i18n: any, locale: string | undefined) => {
	if (!locale) {
		throw new Error('Locale must be defined...');
	}

	if (i18n.mode === 'legacy') {
		i18n.global.locale = locale;
	} else {
		i18n.global.locale.value = locale;
	}

	document.querySelector('html')!.setAttribute('lang', locale);
};

const setupI18n = (options: I18nOptions = {locale: i18n_DEFAULT_LOCALE}) => {
	const i18n = createI18n(options);
	setI18nLanguage(i18n, options.locale);
	return i18n;
};

export const i18n = setupI18n({
	legacy: false,
	locale: window.languageIso ?? i18n_DEFAULT_LOCALE,
	fallbackLocale: i18n_DEFAULT_LOCALE
});
